export default __webpack_public_path__ + "static/media/log-out.0d027006.svg";